export default __webpack_public_path__ + "static/media/userIcon.20d12747.svg";